import {
  PORTFOLIOS_CREATE_ACTIONS,
  PORTFOLIOS_LIST_ACTIONS,
  PORTFOLIOS_EDIT_ACTIONS,
  PORTFOLIOS_DELETE_ACTIONS,
  PORTFOLIOS_POSITION_LIST_ACTIONS,
  POSITION_DELETE_ACTIONS,
  POSITION_EDIT_GET_ACTIONS,
  PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS,
  PORTFOLIOSLIST_POSITION_ACTIONS,
  PORTFOLIO_POSITION_UPDATE_ACTIONS,
  PORTFOLIOS_POSITION_ACTIONS,
  PORTFOLIO_ADD_BYPOSITION,
  POSITION_UNIT_VALUE
} from "../../actionType/portfolios";
import { PORTFOLIOS_EXCEL_LIST_ACTIONS } from "../../actionType/portfolios";

const intialState = {
  portfoliosCreatData: {},
  isPortfoliosCreatLoader: false,
  positionData: {},
  isPositionLoader: false,
  portfoliosList: [],
  isPortfoliosListLoader: true,
  portfoliosDeleteLoader: false,
  portfoliosDeleteData: {},
  portfolioPositionList: [],
  isPortfoliosPositionListLoader: true,
  portfolioPriceByDatePositionList: [],
  isportfolioPriceByDatePositionList: false,
  PositionportfolioList: [],
  isPositionportfolioList: false,
  PositionPortfolio: [],
  trigger: false,
  isPositionPortfolio: false,
  PositionPortfolioUpdate: [],
  isPositionPortfolioUpdate: false,
  positionUnitValue: {},
  portfoliosExcelList: [],
  isPortfoliosExcelListLoader: false,
};

export const portfoliosReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_REQUEST:
      return { ...state, isPortfoliosCreatLoader: true };
    case PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_RESPONSE:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };
    case PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_ERROR:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };

    // PORTFOLIOS_LIST_ACTIONS

    case PORTFOLIOS_LIST_ACTIONS.PORTFOLIOS_LIST_REQUEST:
      return { ...state, isPortfoliosListLoader: true };
    case PORTFOLIOS_CREATE_ACTIONS.PORTFOLIOS_RESPONSE:
      return {
        ...state,
        portfoliosList: payload,
        isPortfoliosListLoader: false,
      };
    case PORTFOLIOS_LIST_ACTIONS.PORTFOLIOS_LIST_RESPONSE:
      return {
        ...state,
        portfoliosList: payload,
        isPortfoliosListLoader: false,
      };

    // PORTFOLIOS_EXCEL_LIST_ACTIONS

    case PORTFOLIOS_EXCEL_LIST_ACTIONS.PORTFOLIOS_EXCEL_LIST_REQUEST:
      return { ...state, isPortfoliosExcelListListLoader: true };
    case PORTFOLIOS_EXCEL_LIST_ACTIONS.PORTFOLIOS_EXCEL_LIST_RESPONSE:
      return {
        ...state,
        portfoliosExcelList: payload,
        isPortfoliosExcelListLoader: false,
      };
    case PORTFOLIOS_EXCEL_LIST_ACTIONS.PORTFOLIOS_EXCEL_LIST_ERROR:
      return {
        ...state,
        portfoliosExcelList: payload,
        isPortfoliosExcelListLoader: false,
      };
    // ADD_PORTFOLIOS_BYPOSITION

    case PORTFOLIO_ADD_BYPOSITION.PORTFOLIO_ADD_BYPOSITION_REQUEST:
      return { ...state, trigger: payload };
    case PORTFOLIO_ADD_BYPOSITION.PORTFOLIO_ADD_BYPOSITION_RESPONSE:
      return {
        ...state,
        trigger: payload,
      };
    // POSITION_UNIT_VALUE

    case POSITION_UNIT_VALUE.POSITION_UNIT_VALUE:
      return { ...state, positionUnitValue: payload };

    // PORTFOLIOS_POSITION_LIST_ACTIONS
    case PORTFOLIOS_POSITION_LIST_ACTIONS.PORTFOLIOS_POSITION_LIST_REQUEST:
      return { ...state, isPortfoliosPositionListLoader: true };
    case PORTFOLIOS_POSITION_LIST_ACTIONS.PORTFOLIOS_POSITION_LIST_RESPONSE:
      return {
        ...state,
        portfolioPositionList: payload,
        isPortfoliosPositionListLoader: false,
      };
    case PORTFOLIOS_POSITION_LIST_ACTIONS.PORTFOLIOS_POSITION_LIST_RESPONSE:
      return {
        ...state,
        portfolioPositionList: payload,
        isPortfoliosPositionListLoader: false,
      };

    // PORTFOLIOS_EDIT_ACTIONS

    case PORTFOLIOS_EDIT_ACTIONS.PORTFOLIOS_EDIT_REQUEST:
      return { ...state, isPortfoliosCreatLoader: true };
    case PORTFOLIOS_EDIT_ACTIONS.PORTFOLIOS_EDIT_RESPONSE:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };
    case PORTFOLIOS_EDIT_ACTIONS.PORTFOLIOS_EDIT_ERROR:
      return {
        ...state,
        portfoliosCreatData: payload,
        isPortfoliosCreatLoader: false,
      };
    // PORTFOLIOS_DELETE_ACTIONS

    case PORTFOLIOS_DELETE_ACTIONS.PORTFOLIOS_DELETE_REQUEST:
      return { ...state, portfoliosDeleteLoader: true };
    case PORTFOLIOS_DELETE_ACTIONS.PORTFOLIOS_DELETE_REQUEST:
      return {
        ...state,
        portfoliosDeleteData: payload,
        portfoliosDeleteLoader: false,
      };
    case PORTFOLIOS_DELETE_ACTIONS.PORTFOLIOS_DELETE_ERROR:
      return {
        ...state,
        portfoliosDeleteData: payload,
        portfoliosDeleteLoader: false,
      };
    // POSITION_DELETE_ACTIONS

    case POSITION_DELETE_ACTIONS.POSITION_DELETE_REQUEST:
      return { ...state, portfoliosDeleteLoader: true };
    case POSITION_DELETE_ACTIONS.POSITION_DELETE_REQUEST:
      return {
        ...state,
        portfoliosDeleteData: payload,
        portfoliosDeleteLoader: false,
      };
    case POSITION_DELETE_ACTIONS.POSITION_DELETE_ERROR:
      return {
        ...state,
        portfoliosDeleteData: payload,
        portfoliosDeleteLoader: false,
      };
    // POSITION_EDIT_GET_ACTION

    case POSITION_EDIT_GET_ACTIONS.POSITION_EDIT_GET_REQUEST:
      return { ...state, isPositionLoader: true };
    case POSITION_EDIT_GET_ACTIONS.POSITION_EDIT_GET_RESPONSE:
      return {
        ...state,
        positionData: payload,
        isPositionLoader: false,
      };
    case POSITION_EDIT_GET_ACTIONS.POSITION_EDIT_GET_ERROR:
      return {
        ...state,
        positionData: payload,
        isPositionLoader: false,
      };

    // POSITION_EDIT_PRICEBYDATE_GET_ACTION

    case PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS.PORTFOLIOS_POSITION_PRICEBYDATE_REQUEST:
      return { ...state, isportfolioPriceByDatePositionList: true };
    case PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS.PORTFOLIOS_POSITION_PRICEBYDATE_RESPONSE:
      return {
        ...state,
        portfolioPriceByDatePositionList: payload,
        isportfolioPriceByDatePositionList: false,
      };
    case PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS.PORTFOLIOS_POSITION_PRICEBYDATE_ERROR:
      return {
        ...state,
        portfolioPriceByDatePositionList: payload,
        isportfolioPriceByDatePositionList: false,
      };

    // PORTFOLIOLIST_POSITION_GET_ACTION

    case PORTFOLIOSLIST_POSITION_ACTIONS.PORTFOLIOSLIST_POSITION_REQUEST:
      return { ...state, isPositionportfolioList: true };
    case PORTFOLIOSLIST_POSITION_ACTIONS.PORTFOLIOSLIST_POSITION_RESPONSE:
      return {
        ...state,
        PositionportfolioList: payload,
        isPositionportfolioList: false,
      };
    case PORTFOLIOSLIST_POSITION_ACTIONS.PORTFOLIOSLIST_POSITION_ERROR:
      return {
        ...state,
        PositionportfolioList: payload,
        isPositionportfolioList: false,
      };
    // PORTFOLIOS_POSITION_ACTIONS

    case PORTFOLIOS_POSITION_ACTIONS.PORTFOLIOS_POSITION_REQUEST:
      return { ...state, isPositionPortfolio: true };
    case PORTFOLIOS_POSITION_ACTIONS.PORTFOLIOS_POSITION_RESPONSE:
      return {
        ...state,
        PositionPortfolio: payload,
        isPositionPortfolio: false,
      };
    case PORTFOLIOS_POSITION_ACTIONS.PORTFOLIOS_POSITION_ERROR:
      return {
        ...state,
        PositionPortfolio: payload,
        isPositionPortfolio: false,
      };
    // PORTFOLIO_POSITION_UPDATE_ACTION

    case PORTFOLIO_POSITION_UPDATE_ACTIONS.PORTFOLIO_POSITION_UPDATE_REQUEST:
      return { ...state, isPositionPortfolioUpdate: true };
    case PORTFOLIO_POSITION_UPDATE_ACTIONS.PORTFOLIO_POSITION_UPDATE_RESPONSE:
      return {
        ...state,
        PositionPortfolioUpdate: payload,
        isPositionPortfolioUpdate: false,
      };
    case PORTFOLIO_POSITION_UPDATE_ACTIONS.PORTFOLIO_POSITION_UPDATE_ERROR:
      return {
        ...state,
        PositionPortfolioUpdate: payload,
        isPositionPortfolioUpdate: false,
      };
    default:
      return state;
  }
};
